import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${API_URLS.TRANSPORTS}/clients`;

async function fetchClients(companyId) {
  try {
    const query = companyId ? `?CompanyId=${companyId}` : "";
    const response = await api.get(`${basePath}${query}`);

    const treated = errorHandling.handleResponse(
      response,
      "transportsClientsService.fetchClients"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "transportsClientsService.fetchClients");
    return null;
  }
}

async function saveClient(payload) {
  try {
    const response = await api.post(basePath, JSON.stringify(payload));

    const treated = errorHandling.handleResponse(
      response,
      "transportsClientsService.saveClient"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "transportsClientsService.saveClient");
    return {
      error: true,
      status: error?.response?.status,
      message: error?.response?.data?.message,
      validations: error?.response?.data?.validations,
    };
  }
}

async function deleteClient(companyId) {
  try {
    const response = await api.delete(`${basePath}/${companyId}`);

    if (response.status === 204) {
      return { success: true };
    }

    const treated = errorHandling.handleResponse(
      response,
      "transportsClientsService.deleteClient"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "transportsClientsService.deleteClient");
    return {
      error: true,
      status: error?.response?.status,
      message: error?.response?.data?.message,
      validations: error?.response?.data?.validations,
    };
  }
}

export const transportsClientsService = {
  fetchClients,
  saveClient,
  deleteClient,
};
